module.exports = __webpack_public_path__ + "img/userIcon.4996ff1b.png";